module.exports = __webpack_public_path__ + "static/jeje-bdda7a7d4f2642ce3259601c5cb5d796.png";